import React from 'react';
import '../../../../../less/mobile/index.less';
import MenuItem from '../../../../../views/menuItem.c';
import arrowLeft from '../../../../../img/new/mobile/arrow-left.svg'
import InsideMenuItem from '../../../../../views/insideMenuItem.c';
import SearchInput from '../../../../../views/searchInput.c';
import { getMenuConfig } from '../../../../../getMenuConfig.js';
import backRowTitles from '../../../../../enums/mobile/back_row_titles.json';
import { ReactSVG } from 'react-svg';

export default function template() {
  const { active, navigate, activeSub, isBusiness, activeMenu } = this.props;

  const renderSubMenuItems = (items) => 
    items.map((item) => {
      return <MenuItem
        activeSub={activeSub}
        alias={activeMenu}
        navigate={navigate}
        url={item.url}
        onClick={this.props.toggle}
      >
        {this.l10n(item.title)}
    </MenuItem>
    }
  )

  const menu = getMenuConfig().find(c => c.alias === activeMenu);

  return (
    <div className="module-header-mobile__menu">
      <div className="module-header-mobile__menu__content">
        <div className="module-header-mobile__menu__back__row">
          <MenuItem
            active={active}
            alias="main"
            navigate={navigate}
            url={!isBusiness ? '/' : undefined}
            onClick={() => this.props.changeMenu('main')}
            allowClickWithoutUrl
          >
            <div className="module-header-mobile__menu__back" >
              <ReactSVG src={arrowLeft} className="module-header-mobile__menu__back__icon" />
              {this.l10n(backRowTitles[activeMenu])}
            </div>
          </MenuItem>
        </div>
        <SearchInput navigate={navigate} toggle={this.props.toggle}/>
        <InsideMenuItem menu={menu} bannerCloseHandler={this.props.toggle} navigate={navigate} renderSubMenuItems={renderSubMenuItems} withoutColumnWidth/>
      </div>
    </div>
  );
}